import { ADD_TO_CART, DELETE_STORE_FROM_CART, DELETE_PRODUCT_CART, DELETE_PRODUCTS_FROM_CART, DELETE_CART, ADD_HISTORY, REMOVE_HISTORY} from './actionTypes';

export const addToCart = id => ({
    type: ADD_TO_CART,
    id: id
})

export const deleteStoreFromCart = id => ({
    type: DELETE_STORE_FROM_CART,
    id
})

export const deleteProductCart = id => ({
    type: DELETE_PRODUCT_CART,
    id
})

export const deleteCart = id => ({
    type: DELETE_CART,
    id
})

export const delete_products_from_cart = id => ({  
    type: DELETE_PRODUCTS_FROM_CART,
    id
})

export const addHistory = (his) => {
    return {
        type: ADD_HISTORY,
        payload: his
    }
}

export const removeHistory = () => {
    return {
        type: REMOVE_HISTORY,
        payload: null
    }
}